import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalAccountsPortfolioQuery = graphql(`
  query ClientPortalAccountsPortfolio($id: ID!, $householdId: ID, $portfolioId: ID) {
    portfolio(userId: $id, householdId: $householdId, portfolioId: $portfolioId) {
      id
      netWorth {
        amount
        currencyCode
      }
      clientProfile {
        id
        providerAccounts {
          id
          providerName
          source
          sourceStatus
        }
      }
      portfolioItemGroups {
        name
        totalValue {
          amount
        }
        hiddenFromClientHistoricalValues {
          date
          value {
            amount
            currencyCode
          }
        }
        historicalValues {
          date
          value {
            amount
            currencyCode
          }
        }
        accounts {
          id
          accountName
          custody
          customName
          displayBalance {
            amount
          }
          hiddenFromClient
          hiddenFromNetWorth
          lastUpdatedAt
          mask
          officialName
          productType
          providerAccount {
            providerName
          }
          providerAccountId
          providerLogoUrl
          source
          subtype
          type
        }
        assets {
          id
          assetClass
          description
          hiddenFromClient
          hiddenFromNetWorth
          netValue {
            amount
          }
          liabilities {
            id
            currentBalance {
              amount
            }
            hiddenFromClient
            hiddenFromNetWorth
          }
        }
        liabilities {
          id
          currentBalance {
            amount
          }
          hiddenFromClient
          hiddenFromNetWorth
          name
          providerName
        }
      }
    }
  }
`);

export type ClientPortalAccountsPortfolioResult = ResultOf<typeof ClientPortalAccountsPortfolioQuery>;

export type ClientPortalAccountsItemGroup =
  ClientPortalAccountsPortfolioResult['portfolio']['portfolioItemGroups'][number];

export type ClientPortalAccountsAccount = ClientPortalAccountsItemGroup['accounts'][number];
